import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-image-gallery/styles/css/image-gallery.css';
import Gallery from 'react-image-gallery';
import ResidentialImage from './images/residential.jpg';
import CommercialImage from './images/commercial.jpg';
import ProjectImage from './images/project.jpg';
import './Services.css'; // Create a CSS file for custom styles

// Import your custom project images
import ProjectImage1 from './images/anthony-indraus-Bb9jWuTMPUk-unsplash.jpg';
import ProjectImage2 from './images/Building-Talent-Web-Image-UEI.webp';
import ProjectImage3 from './images/commercial.jpg';
import ProjectImage4 from './images/Electrical-Engineering-Technology-gtc12.png';
import ProjectImage5 from './images/emmanuel-ikwuegbu-_2AlIm-F6pw-unsplash.jpg';
import ProjectImage6 from './images/new-home-electrical-wiring.jpg';
import ProjectImage7 from './images/project.jpg';
import ProjectImage8 from './images/residential-electrical-outlet-install-640x480.jpg';
import ProjectImage9 from './images/residential.jpg';

const Services = () => {
  const [showGallery, setShowGallery] = useState(false);

  const images = [
    {
      original: ResidentialImage,
      thumbnail: ResidentialImage,
      description: 'Residential Electrical Services',
    },
    {
      original: CommercialImage,
      thumbnail: CommercialImage,
      description: 'Commercial Electrical Services',
    },
    {
      original: ProjectImage,
      thumbnail: ProjectImage,
      description: 'Project Gallery',
      onClick: () => setShowGallery(true),
    },
  ];

  // Create an array of project gallery images
  const projectGalleryImages = [
    {
      original: ProjectImage1,
      thumbnail: ProjectImage1,
    },
    {
      original: ProjectImage2,
      thumbnail: ProjectImage2,
    },
    {
      original: ProjectImage3,
      thumbnail: ProjectImage3,
    },
    {
      original: ProjectImage4,
      thumbnail: ProjectImage4,
    },
    {
      original: ProjectImage5,
      thumbnail: ProjectImage5,
    },
    {
      original: ProjectImage6,
      thumbnail: ProjectImage6,
    },
    {
      original: ProjectImage7,
      thumbnail: ProjectImage7,
    },
    {
      original: ProjectImage8,
      thumbnail: ProjectImage8,
    },
    {
      original: ProjectImage9,
      thumbnail: ProjectImage9,
    },
  ];

  return (
    <div className="container">
      <p>
        Mustang Electric, LLC's service division is dedicated to providing exceptional craftsmanship at competitive rates to meet a diverse range of electrical needs and projects. We merge quality, experience, and safety to deliver electrical solutions that consistently surpass expectations in a timely manner. Our commitment to service extends around the clock, 24 hours a day, 7 days a week.
      </p>
      <p>
        Our top priority is ensuring our customers receive immediate assistance from our team of highly skilled and experienced electricians. Our service electricians possess qualifications in industrial, commercial, and retail business electrical installations, among others. Our service department is equipped with a comprehensive set of tools and equipment to handle a wide variety of service calls.
      </p>
      <p>
        Whether you require support with the installation of light fixtures, resolving code violations, or troubleshooting miscellaneous electrical issues, our team is always available and prepared to assist. You can rely on our electricians to be knowledgeable, reliable, and capable. We deeply appreciate the continued opportunity to serve your electrical needs.
      </p>

      <h1 className="mt-5">Our Electrical Services</h1>
      <div className="row">
        {images.map((image, index) => (
          <div key={index} className="col-md-4 service">
            <h2>{image.description}</h2>
            <img src={image.original} alt={image.description} />
            {image.description === 'Project Gallery' && (
              <button className="view-gallery-button" onClick={() => setShowGallery(true)}>
                View Gallery
              </button>
            )}
          </div>
        ))}
      </div>
      <div className="project-gallery">
        {showGallery && (
          <>
            <Gallery items={projectGalleryImages} />
            <button className="close-button" onClick={() => setShowGallery(false)}>
              Close Gallery
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Services;




